// A per-cart id that links every cart_add event to the order it eventually
// becomes, so cart -> order conversion is an exact join. Generated lazily on
// first add, persisted per scope (mirrors the cart's own localStorage keying),
// and rotated on clear/checkout-success so the next cart starts a fresh id.
//
// The scope is the user id for the in-app cart (which is per-user) and
// `express:<handle>` for a storefront's express cart (which may be anonymous).

const KEY_PREFIX = 'marketlink.cartsid.';

function keyFor(scope: string | null | undefined): string | null {
  return scope ? `${KEY_PREFIX}${scope}` : null;
}

export function getCartSessionId(scope: string | null | undefined): string | null {
  const key = keyFor(scope);
  if (!key || typeof window === 'undefined') return null;
  try {
    let id = localStorage.getItem(key);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(key, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function rotateCartSessionId(scope: string | null | undefined): void {
  const key = keyFor(scope);
  if (!key || typeof window === 'undefined') return;
  try {
    localStorage.removeItem(key);
  } catch {
    /* private mode / quota */
  }
}
